/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LootBoxInstanceResponse } from './LootBoxInstanceResponse';
import {
    LootBoxInstanceResponseFromJSON,
    LootBoxInstanceResponseFromJSONTyped,
    LootBoxInstanceResponseToJSON,
    LootBoxInstanceResponseToJSONTyped,
} from './LootBoxInstanceResponse';
import type { LootBoxConfigResponse } from './LootBoxConfigResponse';
import {
    LootBoxConfigResponseFromJSON,
    LootBoxConfigResponseFromJSONTyped,
    LootBoxConfigResponseToJSON,
    LootBoxConfigResponseToJSONTyped,
} from './LootBoxConfigResponse';

/**
 * 
 * @export
 * @interface LootBoxInstanceWithConfig
 */
export interface LootBoxInstanceWithConfig {
    /**
     * 
     * @type {LootBoxInstanceResponse}
     * @memberof LootBoxInstanceWithConfig
     */
    instance: LootBoxInstanceResponse;
    /**
     * 
     * @type {LootBoxConfigResponse}
     * @memberof LootBoxInstanceWithConfig
     */
    config?: LootBoxConfigResponse;
}

/**
 * Check if a given object implements the LootBoxInstanceWithConfig interface.
 */
export function instanceOfLootBoxInstanceWithConfig(value: object): value is LootBoxInstanceWithConfig {
    if (!('instance' in value) || value['instance'] === undefined) return false;
    return true;
}

export function LootBoxInstanceWithConfigFromJSON(json: any): LootBoxInstanceWithConfig {
    return LootBoxInstanceWithConfigFromJSONTyped(json, false);
}

export function LootBoxInstanceWithConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): LootBoxInstanceWithConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'instance': LootBoxInstanceResponseFromJSON(json['instance']),
        'config': json['config'] == null ? undefined : LootBoxConfigResponseFromJSON(json['config']),
    };
}

export function LootBoxInstanceWithConfigToJSON(json: any): LootBoxInstanceWithConfig {
    return LootBoxInstanceWithConfigToJSONTyped(json, false);
}

export function LootBoxInstanceWithConfigToJSONTyped(value?: LootBoxInstanceWithConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instance': LootBoxInstanceResponseToJSON(value['instance']),
        'config': LootBoxConfigResponseToJSON(value['config']),
    };
}

